import {numUtil} from './num';

export function getFundingTime(hours = 8, delay = 0) {
  const now = new Date();
  const h = now.getUTCHours();
  const m = now.getUTCMinutes();
  const s = now.getUTCSeconds();
  const H = (Math.floor(h / hours) + 1) * hours;
  const seconds = (H - h) * 60 * 60 - m * 60 - s + delay / 1000;
  return `${Math.floor(seconds / 3600)}:${numUtil.pad(Math.floor(seconds / 60) % 60)}:${numUtil.pad(seconds % 60)}`;
}
